import { createUseStyles } from 'react-jss'

import { darkGrey, lightGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: 40
  },
  iconContainer: {
    width: 60,
    minWidth: 60,
    height: 60,
    padding: '5px 10px',
    border: `2.4px solid ${lightGrey}`,
    borderRadius: 9.6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    marginRight: 25
  },
  icon: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 40
  },
  name: {
    fontWeight: 800,
    fontSize: 18,
    lineHeight: '22px'
  },
  nameBottomText: {
    marginTop: 5,
    color: darkGrey
  },
  value: {
    height: 0
  }
})

export default useStyles
